import React from 'react';
import classNames from 'classnames';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';
import { CYCLE_MODES } from 'utils/constants';

const MachineStatusSelection = (props) => {
  const {
    onBack,
    onNext,
    onValueChange,
    selectedMachineStatus,
  } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>Choose the status to simulate</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>Select the status of the machine you would like to simulate</p>
          <Autocomplete
            disablePortal
            id="autocomplete-choose-machine-status"
            options={Object.keys(CYCLE_MODES)}
            sx={{ width: '300px' }}
            onChange={(event, value) => {
                onValueChange(value);
            }}
            renderInput={(params) => <TextField {...params} label="Machine Status" />}
            value={selectedMachineStatus}
          />
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !selectedMachineStatus,
          })}
          disabled={!selectedMachineStatus}
          onClick={onNext}
        >
          Next
        </button>
      </footer>
    </>
  );
};

export default MachineStatusSelection;
